
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardiology",
      function () {
        return require("private-next-pages/cardiology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardiology"])
      });
    }
  